import React from "react";
import { Modal, Button, Image } from "react-bootstrap";

const DeleteModal = ({onDelete, show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center">
        <div className="mb-3">
          <Image src="/assets/images/Delete-main.svg" alt="Delete Icon" />
        </div>
        <p className="font-14 font-weight-medium mb-4">
          Are you sure, You want to delete this?
        </p>
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button className="delete-btn" variant="danger"
              onClick={onDelete}
          >
       
            Delete
          </button>
          <button className="c-b-btn" variant="secondary" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
